import productSlice from "../slices/productSlice";

export const productReducers = {
  product: productSlice,
};
